import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Children, cloneElement, isValidElement, memo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { Spacing } from '../Spacing';
import { sizes, ICON_SELECTED_BORDER_WIDTH, ICON_HOVER_GAP, } from './constants';
import { IconPickerContext } from './IconPickerContext';
const defaultProps = {
    border: false,
    className: '',
    label: '',
    onChange: () => { },
    size: sizes.medium,
    value: '',
};
const IconPicker = ({ border = defaultProps.border, children, className = defaultProps.className, label = defaultProps.label, name, onChange = defaultProps.onChange, size = defaultProps.size, value = defaultProps.value, }) => {
    // @ts-ignore 2339
    const icon = Children.toArray(children).find((child) => child.props.value === value);
    // @ts-ignore 2339
    const iconName = icon ? icon.props.name : '';
    const pickerStyles = css `
    display: flex;
    flex-wrap: wrap;
    margin: ${styleUtils.rem(ICON_SELECTED_BORDER_WIDTH + ICON_HOVER_GAP)};
  `;
    return (_jsxs("div", Object.assign({ className: className }, { children: [label && (_jsx(Spacing, Object.assign({ bottom: "extraSmall" }, { children: _jsxs("div", Object.assign({ css: theme.typeStyles.bodyMediumStyles, "data-test-ref": "icon-picker-label" }, { children: [_jsxs("span", Object.assign({ css: theme.typeStyles.bodyBoldStyles }, { children: [label, iconName && ':'] })), _jsx("span", { children: ` ${iconName}` })] })) }))), _jsx("div", Object.assign({ css: pickerStyles }, { children: _jsx(IconPickerContext.Provider, Object.assign({ value: {
                        border,
                        onChange,
                        pickerName: name,
                        selectedValue: value,
                        size,
                    } }, { children: Children.map(children, (child, index) => (isValidElement(child)
                        ? cloneElement(child, Object.assign({ id: `icon-${name}-${index}`, lastChild: index === Children.count(children) - 1 }, child.props))
                        : null)) })) }))] })));
};
const MemoizedIconPicker = memo(IconPicker);
export { MemoizedIconPicker as IconPicker };
// MC-1068 Temporary hack for Storybook.
export default IconPicker;
